var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.7778V17.7778M10.5 10.7778V17.7778M6.5 6.77783V18.5778C6.5 19.6979 6.5 20.2576 6.71799 20.6854C6.90973 21.0617 7.21547 21.3683 7.5918 21.5601C8.0192 21.7778 8.57899 21.7778 9.69691 21.7778H15.3031C16.421 21.7778 16.98 21.7778 17.4074 21.5601C17.7837 21.3683 18.0905 21.0617 18.2822 20.6854C18.5 20.258 18.5 19.6988 18.5 18.5809V6.77783M6.5 6.77783H8.5M6.5 6.77783H4.5M8.5 6.77783H16.5M8.5 6.77783C8.5 5.84595 8.5 5.38024 8.65224 5.0127C8.85523 4.52264 9.24432 4.13306 9.73438 3.93007C10.1019 3.77783 10.5681 3.77783 11.5 3.77783H13.5C14.4319 3.77783 14.8978 3.77783 15.2654 3.93007C15.7554 4.13306 16.1447 4.52264 16.3477 5.0127C16.4999 5.38024 16.5 5.84595 16.5 6.77783M16.5 6.77783H18.5M18.5 6.77783H20.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFull);
export default __webpack_public_path__ + "static/media/Trash_Full.cd37823f4ba4a2baf13ab5dff07a6889.svg";
export { ForwardRef as ReactComponent };